import React from 'react';
import { findCompByIdRecursively, recalculateIndexes } from '../../utils/functions';
import { placeholder64 } from '../../utils/layoutConfig';
import { toPng } from 'html-to-image';
import { useDispatch, useSelector } from 'react-redux';
import defaultPages from '../../utils/defaultPages';
import { allPages, updatePages } from '../../redux/pagesSlice';
import { selectedPage, selectPage } from '../../redux/selectedPageSlice';
import queries from '../../utils/query';
import { useQuery, useMutation } from '@apollo/client';
import { DragDropContext } from 'react-beautiful-dnd';
import { scrollBarStyle } from '../../utils/layoutConfig';
import DefaultProps from '../../utils/defaultProps';
import { Box, Text, useToast } from '@chakra-ui/react';
import LeftMenu from '../canvas/LeftMenu';
import RenderGroupListSA from './RenderGroupListSA';
import { selectedToggleValue } from '../../redux/canvasResolutionSlice';
import { availableComponents } from '../../utils/layoutConfig';
import { filterByMobileState } from '../../utils/functions';

let viewPreviewLastUpdate = null;
const jsonDiff = require('jsondiffpatch').create();

function generateViewPreview({ imgRef }) {
	return new Promise((resolve, reject) => {
		if (!imgRef || !imgRef.current) {
			resolve(placeholder64);
		}
		const w = imgRef.current.offsetWidth;
		const h = imgRef.current.offsetHeight;
		const ratio = Math.round(w / 250);
		const newW = w / ratio;
		const newH = h / ratio;
		const opts = { canvasWidth: newW };

		if (newH < 500) {
			opts.canvasHeight = newH;
		} else {
			opts.heigth = 500;
		}

		toPng(imgRef.current, opts)
			.then((png) => {
				if (png === 'data:,') {
					resolve(placeholder64);
				} else {
					resolve(png);
				}
			})
			.catch((e) => {
				resolve(placeholder64);
			});
	});
}

function generatePlaceholderProps({ e }) {
	const draggedDOM = getDraggedDom(e);
	if (!draggedDOM) {
		return null;
	}

	if (!e.destination) return null;

	let placeholderProps = {};
	let DOMSpread = [];
	let updatedArray = [];
	const destinationIndex = e.destination.index;
	const sourceIndex = e.source.index;
	const { clientHeight, clientWidth } = draggedDOM;

	if (e.source.droppableId.includes('AvailableComponents')) {
		DOMSpread = [...document.getElementsByClassName('placeholder-container')[0].children];
		updatedArray = getUpdatedArray({ movedItem: draggedDOM, DOMSpread, destinationIndex });
		placeholderProps = {
			clientHeight: 113,
			clientWidth: '100%',
			clientX: 0,
		};
	} else {
		const movedItem = DOMSpread[sourceIndex];
		DOMSpread = [...draggedDOM.parentElement.children];
		updatedArray = getUpdatedArray({ movedItem, sourceIndex, DOMSpread, destinationIndex });
		placeholderProps = {
			clientHeight,
			clientWidth,
			clientX: parseFloat(window.getComputedStyle(draggedDOM.parentNode).paddingLeft),
		};
	}

	const clientY =
		parseFloat(window.getComputedStyle(draggedDOM).paddingTop) +
		updatedArray.slice(0, destinationIndex).reduce((total, curr) => {
			const style = curr.currentStyle || window.getComputedStyle(curr);
			const marginBottom = parseFloat(style.marginBottom);
			const marginTop = parseFloat(style.marginTop);
			return total + curr.clientHeight + marginBottom + marginTop;
		}, 0);

	placeholderProps.clientY = clientY;

	return placeholderProps;
}

function getUpdatedArray({ movedItem, sourceIndex, DOMSpread, destinationIndex }) {
	if (sourceIndex || sourceIndex == 0) {
		DOMSpread.splice(sourceIndex, 1);
	}
	return [...DOMSpread.slice(0, destinationIndex), movedItem, ...DOMSpread.slice(destinationIndex + 1)];
}

function getDraggedDom({ draggableId, source }) {
	const domQuery = `[data-rbd-drag-handle-draggable-id='${draggableId}']`;
	const draggedDOM = source.droppableId.includes('AvailableComponents')
		? document.querySelector(domQuery).parentNode
		: document.querySelector(domQuery);

	return draggedDOM;
}

function setTemplates(pages, templateId) {
	pages.forEach(({ pageData }, index) => {
		pageData.forEach((_, pageDataIndex) => {
			if (!pages[index].pageData[pageDataIndex].templateId)
				pages[index].pageData[pageDataIndex].templateId = templateId;
		});
	});
}

const DragDropContextContainerSA = ({ viewId, userInfo, isDebugActive }) => {
	const dispatch = useDispatch();
	const pages = useSelector(allPages);
	const selectedCanvasResolution = useSelector(selectedToggleValue);
	// const VMMode = useSelector(visualizationMode);
	const selectedPageValue = useSelector(selectedPage);
	const templateId = 1;
	const defaultPagesObject = defaultPages(templateId);
	const toast = useToast();
	//componentes
	const [componentList, setComponentList] = React.useState([]); //lista de componentes disponíveis
	const [filteredComponentList, setFilteredComponentList] = React.useState([]); //Para o resultado de busca
	// const [components, setComponents] = React.useState(false) //componentes selecionados
	const [tabIndex, setTabIndex] = React.useState(-1); //components tabindex

	//Database - pegando projeto e atualizando projeto
	const { loading, error, data } = useQuery(queries.GET_VIEW(viewId));
	const [updateViewListPreview] = useMutation(queries.UPDATE_VIEW_PREVIEW);

	const [lastPages, setLastPages] = React.useState([]);
	// const [dummyPages, setDummyPages] = React.useState([]); //dummy pages para simular o que foi alterado no commit -- fazer para que alteração afete apenas a pág, não o todo

	//ref da box que será usada para gerar a imagem de thumb do projeto
	const imgRef = React.useRef(null);
	//criando nova alteração
	const [createCommit] = useMutation(queries.CREATE_COMMIT);

	//placeholder
	const [placeholderProps, setPlaceholderProps] = React.useState({});

	//page from queryString
	React.useEffect(() => {
		const page = window.location.hash;
		if (pages && page && page != selectedPageValue) {
			const newPage = page.replace('#', '');
			if (!newPage) {
				return;
			}
			dispatch(selectPage(newPage));
		}
	}, [window.location.hash, pages]);

	//No retorno do apollo, preenchendo o pages
	React.useEffect(() => {
		if (data && data.view && data.view.jsonContent) {
			if (data.view.jsonContent != '[]') {
				const contentString = data.view.jsonContent;
				try {
					// setPages(JSON.parse(contentString))
					const pages = JSON.parse(contentString);
					//fix, remover no futuro
					// setTemplates(pages, templateId);
					dispatch(updatePages(pages));

					setLastPages(JSON.parse(contentString));
				} catch (e) {
					console.error(e); //Caso não seja uma string json
				}
			} else {
				// setTemplates(newDefaultPages, templateId);
				dispatch(updatePages(defaultPagesObject));
				// setPages(defaultPages)
			}
		}
	}, [data]);

	React.useEffect(() => {
		if (error) {
			toast({
				title: 'Erro ao obter projeto',
				description: 'Ocorreu um erro ao tentar obter o projeto do banco de dados',
				status: 'error',
				duration: 5000,
				isClosable: true,
			});
		}
	}, [error]);
	//Atualizando bd quando há mudança de estado nas páginas
	React.useEffect(() => {
		window.pages = pages;
		let timeout;
		const pageString = pages ? JSON.stringify(pages) : '{}';
		const lastPageString = lastPages ? JSON.stringify(lastPages) : '{}';
		if (data && !loading && lastPageString !== pageString) {
			const delta = jsonDiff.diff(lastPages, pages);
			if (delta && delta !== 'no diff') {
				const userData = userInfo;
				createCommit({
					variables: {
						viewId: String(viewId),
						commitValue: JSON.stringify(delta),
						userId: userData.id,
						userEmail: userData.name,
						userName: userData.email,
					},
				});

				const dateNow = new Date();

				if (!viewPreviewLastUpdate || Math.abs(viewPreviewLastUpdate.getTime() - dateNow.getTime()) > 1000 * 10) {
					timeout = setTimeout(() => {
						generateViewPreview({ imgRef }).then((img) => {
							viewPreviewLastUpdate = dateNow;
							updateViewListPreview({
								variables: {
									viewId: String(viewId),
									viewPreview: img,
								},
							});
						});
					}, 3000);
				}

				setLastPages(JSON.parse(pageString));
			}
		}

		return () => {
			clearTimeout(timeout);
		};
	}, [pages]);

	function onDragEnd(result) {
		const { destination, source, draggableId } = result;
		if (!destination || (destination.droppableId === source.droppableId && destination.index === source.index)) {
			return;
		}
		if (destination.droppableId) {
			moveElement({ destination, source, draggableId });
		}
	}

	function moveElement({ destination, source, draggableId }) {
		const newPages = JSON.parse(JSON.stringify(pages));
		const newSelectedPage = newPages.find((el, index) => {
			return el.pageId == selectedPageValue;
		});
		const destId = destination.droppableId.replace('-droppable', '');
		const { comp } = findCompByIdRecursively(newSelectedPage.pageData, destId);

		if (source.droppableId.includes('AvailableComponents')) {
			const avComponents = availableComponents[0].components;
			const newElement = avComponents.find((el) => el.id === draggableId);

			if (
				!newElement ||
				(!newElement.draggableType.includes(selectedPageValue) && !newElement.draggableType.includes('DEFAULT'))
			) {
				toast({
					title: 'Este componente não pode ser usado nesta página',
					status: 'error',
					duration: 5000,
					isClosable: true,
				});
				return;
			}

			if (destination.droppableId == 'CANVAS') {
				const props = DefaultProps[draggableId];
				const newElement = typeof props === 'function' ? props() : props;
				// newElement.componentId = uuidv4()
				newElement.templateId = 1;

				//if pageType is search, add new element to newSelectedPage.pageData with prop moveTo as desktop or mobile
				//  let parentIndex = 0
				if (newSelectedPage.pageType == 'search') {
					if (selectedCanvasResolution > 1024) {
						newElement.moveTo = 'desktop';
					} else {
						newElement.moveTo = 'mobile';
					}
				}
				//  if (newSelectedPage.pageType === "search") {
				//      if (selectedCanvasResolution > 1024) {
				//          newElement.moveTo = "desktop";
				//          parentIndex = newSelectedPage.pageData.findIndex((el)=>el.componentGroup == "SearchResultLayoutDesktop")
				//      } else {
				//          newElement.moveTo = "mobile";
				//          parentIndex = newSelectedPage.pageData.findIndex((el)=>el.componentGroup == "SearchResultLayoutMobile")
				//      }

				//      let nOfElementsBefore = 0
				//      newSelectedPage.pageData.forEach((el,index)=>{
				//          if(index>=destination.index) return
				//          if(el.moveTo == newElement.moveTo || el?.componentGroup.includes(newElement.moveTo)) nOfElementsBefore++
				//      })

				//      if(parentIndex>=destination.index){
				//          newElement.moveIndex = nOfElementsBefore
				//      }else{
				//          newElement.moveIndex = nOfElementsBefore + newSelectedPage.pageData[parentIndex].childrenComponents.length
				//      }

				//      newSelectedPage.pageData.forEach((el)=>{
				//          if(el.moveTo == newElement.moveTo && el.moveIndex >= newElement.moveIndex){
				//              el.moveIndex++
				//          }
				//      })
				//  }

				newSelectedPage.pageData.push({
					...newElement,
				});
				const len = newSelectedPage.pageData.length;
				newSelectedPage.pageData.swap(len - 1, destination.index);
				recalculateIndexes(newSelectedPage);
			}
		} else {
			if (destination.droppableId == source.droppableId) {
				if (destId == 'CANVAS') {
					const mapping = {
						mobile: {},
						desktop: {},
					};
					if (newSelectedPage.pageType == 'search') {
						//for each componentGroup includes "mobile"

						//filter by mobileState to generate the mapping correctly
						const newPageMobile = newSelectedPage.pageData.filter((el) => filterByMobileState(el, 1000));
						const newPageDesk = newSelectedPage.pageData.filter((el) => filterByMobileState(el, 1500));

						newSelectedPage.pageData.map((origEl, index) => {
							const m = newPageMobile.findIndex((el) => el.componentId == origEl.componentId);
							const d = newPageDesk.findIndex((el) => el.componentId == origEl.componentId);
							if (m >= 0) mapping['mobile'][m] = index;
							if (d >= 0) mapping['desktop'][d] = index;
						});
						console.log(mapping);
						if (selectedCanvasResolution > 1024) {
							newSelectedPage.pageData.swap(mapping['desktop'][source.index], mapping['desktop'][destination.index]);
						} else {
							newSelectedPage.pageData.swap(mapping['mobile'][source.index], mapping['mobile'][destination.index]);
						}
					} else {
						newSelectedPage.pageData.swap(source.index, destination.index);
					}
					console.log(newSelectedPage.pageData);
					recalculateIndexes(newSelectedPage);
				} else {
					comp.childrenComponents.swap(source.index, destination.index);
				}
			} else {
				//não é a msm source, mudando componente de array
				const sourceResult = findCompByIdRecursively(newSelectedPage.pageData, draggableId);
				const sourceIndex = sourceResult.index;
				const sourceArr = sourceResult.parentArray;
				const sourceComp = sourceResult.comp;
				//removendo do original source p não duplicar
				sourceArr.splice(sourceIndex, 1);
				//ignorando por hora os indexes
				if (comp.childrenComponents) {
					comp.childrenComponents.push(sourceComp);
				} else {
					comp.childrenComponents = [sourceComp];
				}
			}
		}
		dispatch(updatePages(newPages));
		// setPages(newPages)
	}

	function onDragStart(e) {
		const placeholderProps = generatePlaceholderProps({ e });
		if (placeholderProps) setPlaceholderProps(placeholderProps);
	}

	function onDragUpdate(e) {
		if (!e.destination) {
			return;
		}

		const placeholderProps = generatePlaceholderProps({ e });
		if (placeholderProps) setPlaceholderProps(placeholderProps);
	}
	const parentBoxProps = {
		flex: '1',
		ref: imgRef,
		alignSelf: 'center',
		// w: selectedCanvasResolution > 1024 ? "100%" : selectedCanvasResolution + "px",
		h: '100%',
		shadow: 'lg',
		order: 1,
		bg: 'white',
	};
	return (
		<DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart} onDragUpdate={onDragUpdate}>
			<LeftMenu
				{...{
					viewId,
					setRecentCommitsIsOpen: false,
					tabIndex,
					setTabIndex,
					leftDrawerIsOpen: true,
					setLeftDrawerIsOpen: () => null,
					setComponentList,
					filteredComponentList,
					componentList,
					noMarginTop: true,
				}}
			/>
			<Box
				{...parentBoxProps}
				className="RenderGroupListSA"
				alignSelf={'flex-end'}
				position={'relative'}
				display={'flex'}
				flexDir={'column'}
				w={'100%'}
				h={'calc(100% - 76px)'}
				top={'-76px'}
				flexBasis={'auto'}
				margin={'0'}
			>
				<Box overflow={'auto'} sx={scrollBarStyle}>
					<FixedHeader {...{ selectedPageValue }} />
					<Box display={'flex'} w={'100%'} flexDir={'column'} h={'auto'} flex={1}>
						<RenderGroupListSA {...{ placeholderProps, imgRef, isDebugActive }} />
					</Box>
					<FixedFooter {...{ selectedPageValue }} />
				</Box>
			</Box>
		</DragDropContext>
	);
};

const FixedHeader = ({ selectedPageValue }) => {
	if (selectedPageValue?.includes('header') || selectedPageValue?.includes('footer')) return null;
	return (
		<Box {...elementProps}>
			<Box {...elementBorder}>
				<Text {...textStyle}>Header</Text>
			</Box>
		</Box>
	);
};
const FixedFooter = ({ selectedPageValue }) => {
	if (selectedPageValue?.includes('header') || selectedPageValue?.includes('footer')) return null;
	return (
		<Box {...elementProps}>
			<Box {...elementBorder}>
				<Text {...textStyle}>Footer</Text>
			</Box>
		</Box>
	);
};

const elementProps = {
	bg: 'white',
	width: '100%',
	backgroundColor: '#eee',
	padding: '0px',
	d: 'flex',
};

const elementBorder = {
	border: 'solid 2px #bcbcbc',
	borderRadius: '3px',
	margin: '8px 8px 5px 8px',
	w: '100%',
	verticalAlign: 'middle',
	d: 'flex',
};

const textStyle = {
	color: '#bcbcbc',
	fontWeight: 700,
	fontSize: '18px',
	alignSelf: 'center',
	margin: '0 auto',
};

export default DragDropContextContainerSA;
